import React from 'react';
import "./home.css"
import Login from './Login';
import GroupsPDF from "../FileToDisplay/KMITPS-2022-S1-TEAMS.pdf"
import firmware from '../Logos/firmware.svg'
function Home({ IP }) {

    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-lg-8 col-md-7 col-sm-6 text-center'>
                    <div className="card w-100 border-0 mt-5">
                        <img className="card-img-top m-auto" style={{ marginTop: "20px", width: "65%" }} src={firmware} alt="image" />
                    </div>
                    {/* <div className='row mt-5'>
                        <div className='col-md-6'>
                            <div className="card w-100 h-100">
                                <img className="card-img-top" src={virtual_reality} alt="virtual_reality" />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="card w-100 h-100">
                                <img className="card-img-top" src={drone} alt="drone" />
                            </div>
                        </div>
                    </div>
                    <div className='row mt-5'>
                        <div className='col-md-6'>
                            <div className="card w-100 h-100">
                                <img className="card-img-top" src={drone} alt="drone" />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="card w-100 h-100">
                                <img className="card-img-top" src={virtual_reality} alt="virtual_reality" />
                            </div>
                        </div>
                    </div> */}
                </div>
                <div className='col-lg-4 col-md-5 col-sm-6'>
                    <Login IP={IP} />
                </div>
            </div>
        </div>
    )
}

export default Home